export default {
    withPrivacyNotice: true
};
